import { render, staticRenderFns } from "./RevisionWorkspace.vue?vue&type=template&id=14d9d76e"
import script from "./RevisionWorkspace.vue?vue&type=script&lang=js"
export * from "./RevisionWorkspace.vue?vue&type=script&lang=js"
import style0 from "./RevisionWorkspace.vue?vue&type=style&index=0&id=14d9d76e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports